export interface Chat {
    id: string;
    aliases?: string[];
    name: string;
    phone?: string;
    profilePicUrl?: string | null;
    lastMessage?: string;
    unreadCount?: number;
    timestamp?: number;
}

export interface VCardContact {
  name?: string;
  phone?: string;
  email?: string;
  org?: string;
  title?: string;
  rawVCard?: string;
}

export interface WhatsAppMessage {
  id: string;
  message: string;
  sender?: string;
  direction: 'incoming' | 'outgoing';
  position: 'single' | 'first' | 'normal' | 'last';
  fromMe?: boolean;
  chatId: string;
  timestamp: number;
  profilePicUrl?: string;
  type: 'chat' | 'image' | 'audio' | 'video' | 'document' | 'ptt' | 'sticker' | 'error' | 'location' | 'vcard' | 'call_log' | 'revoked' | 'group_notification' | string;
  hasMedia: boolean;
  mimetype?: string;
  filename?: string;
  mediaData?: string;
  error?: string;
  location?: { latitude: number; longitude: number; description?: string };
  vcard?: string | VCardContact;
  parsedVCard?: VCardContact;
  ack?: number;
  sendStatus?: 'pending' | 'sent' | 'failed' | 'unknown';
  sendError?: string;
  mediaRequiresDownload?: boolean;
  hasQuotedMsg?: boolean;
  quotedMessage?: WhatsAppMessage;
  hasReaction?: boolean;
  reactions?: { emoji: string; count: number }[];
  historySource?: 'whatsapp' | 'archive';
  isArchivedOnly?: boolean;
}

export interface CreateChatPayload {
  phoneNumber: string;
  name?: string;
}

export interface ContactActionHandlers {
  onCall?: (phone: string) => void;
  onMessage?: (phone: string) => void;
  onEmail?: (email: string) => void;
  onSaveContact?: (contact: VCardContact) => void;
  onViewContact?: (contact: VCardContact) => void;
  onCreateChat?: (phoneNumber: string, name?: string) => void;
}

export interface MediaToSend {
    mimetype: string;
    data: string; // Base64 data
    filename: string;
}

export interface PresenceUpdateData {
    chatId: string;
    status: 'available' | 'unavailable' | 'composing' | 'recording';
    lastSeen?: number; // Timestamp (seconds)
}

// Placeholder for avatar SVG data
export const PLACEHOLDER_AVATAR_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23cccccc'%3E%3Cpath fill-rule='evenodd' d='M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z' clip-rule='evenodd' /%3E%3C/svg%3E";

// Define the unified payload structure for sending messages via socket
export interface SendMessagePayload {
    chatId: string;
    clientMessageId?: string;
    phone?: string;
    message: string; // Text content or caption for media
    media?: MediaToSend | MediaToSend[] | null;
    quotedMessageId?: string;
    options?: {
        sendAudioAsVoice?: boolean;
    };
}
